(function (global) {
    const rules =
    {
        "version": 1,
        "baseFlag": "can_purchase",
        "contexts": {
            "default": {
                "requireBaseFlag": true,
                "denyTags": []
            },
            "bulk_order": {
                "requireBaseFlag": false,
                "denyTags": [
                    "Courses & Kits"
                ]
            }
        },
        "allowTags": [
            "Starter Kit",
            "OpenProduct"
        ],
        "vendors": [
            {
                "name": "Bio Sculpture",
                "fullAccessFlag": "can_purchase_bio",
                "denyTypesWithFullAccess": [
                    {
                        "type": "Bio Sculpture Treatment",
                        "flag": "can_not_purchase_bio_treatment"
                    },
                    {
                        "type": "Bio Sculpture Colour",
                        "flag": "can_not_purchase_bio_colour"
                    }
                ],
                "allowTypesWithoutFullAccess": [
                    {
                        "type": "Bio Sculpture Treatment",
                        "flag": "can_purchase_bio_treatment"
                    },
                    {
                        "type": "Bio Sculpture Colour",
                        "flag": "can_purchase_bio_colour"
                    },
                    {
                        "type": "Ethos",
                        "flag": "can_purchase_bio_ethos"
                    },
                    {
                        "type": "Gemini Nail Polish",
                        "flag": "can_purchase_bio_gemini"
                    }
                ]
            },
            {
                "name": "Evo",
                "fullAccessFlag": "can_purchase_evo",
                "denyTypesWithFullAccess": [
                    {
                        "type": "Evo Treatment",
                        "flag": "can_not_purchase_evo_treatment"
                    }
                ],
                "allowTypesWithoutFullAccess": []
            },
            {
                "name": "Elim",
                "fullAccessFlag": "can_purchase_elim",
                "denyTypesWithFullAccess": [],
                "allowTypesWithoutFullAccess": [],
                "allowTagsWithoutFullAccess": [
                    {
                        "tag": "MediHand",
                        "flag": "can_purchase_elim_medihand"
                    }
                ]
            }
        ],
        "allowOverrides": [
            {
                "tag": "AvailableToElim",
                "flag": "can_purchase_elim"
            },
            {
                "tag": "AvailableToBio",
                "flag": "can_purchase_bio"
            }
        ],
        "postDenyTags": [
            {
                "tag": "Bio Sculpture Trial",
                "flag": "can_not_purchase_bio_trial"
            },
            {
                "tag": "Elim Trial",
                "flag": "can_not_purchase_elim_trial"
            },
            {
                "tag": "Tint Trial",
                "flag": "can_not_purchase_tint_trial"
            }
        ]
    };

    function evaluatePurchaseRules(product, customerData, context) {
        const purchaseContext = context || "default";

        if (!product) {
            return false;
        }

        const contextRules = rules.contexts[purchaseContext];
        if (!contextRules) {
            throw new Error(`Unknown purchase rules context '${purchaseContext}'`);
        }

        const productTags = normalizeProductTags(product.tags);

        for (const denyTag of contextRules.denyTags) {
            if (productHasTag(productTags, denyTag)) {
                return false;
            }
        }

        for (const allowTag of rules.allowTags) {
            if (productHasTag(productTags, allowTag)) {
                return true;
            }
        }

        if (contextRules.requireBaseFlag && !customerHasFlag(customerData, rules.baseFlag)) {
            return false;
        }

        let canPurchase = true;

        for (const vendorRule of rules.vendors) {
            if (product.vendor !== vendorRule.name) {
                continue;
            }

            if (customerHasFlag(customerData, vendorRule.fullAccessFlag)) {
                for (const denyRule of vendorRule.denyTypesWithFullAccess) {
                    if (
                        customerHasFlag(customerData, denyRule.flag) &&
                        productIsType(product, denyRule.type)
                    ) {
                        canPurchase = false;
                        break;
                    }
                }
            } else {
                canPurchase = false;

                for (const allowRule of vendorRule.allowTypesWithoutFullAccess) {
                    if (
                        customerHasFlag(customerData, allowRule.flag) &&
                        productIsType(product, allowRule.type)
                    ) {
                        canPurchase = true;
                        break;
                    }
                }

                if (!canPurchase) {
                    for (const allowRule of vendorRule.allowTagsWithoutFullAccess || []) {
                        if (
                            customerHasFlag(customerData, allowRule.flag) &&
                            productHasTag(productTags, allowRule.tag)
                        ) {
                            canPurchase = true;
                            break;
                        }
                    }
                }
            }
        }

        for (const overrideRule of rules.allowOverrides) {
            if (
                customerHasFlag(customerData, overrideRule.flag) &&
                productHasTag(productTags, overrideRule.tag)
            ) {
                canPurchase = true;
            }
        }

        if (canPurchase) {
            for (const denyRule of rules.postDenyTags) {
                if (
                    customerHasFlag(customerData, denyRule.flag) &&
                    productHasTag(productTags, denyRule.tag)
                ) {
                    canPurchase = false;
                    break;
                }
            }
        }

        return canPurchase;
    }

    function customerHasFlag(customerData, flag) {
        if (!customerData) {
            return false;
        }

        return customerData[flag] === true || customerData[flag] === "true";
    }

    function normalizeProductTags(tags) {
        if (Array.isArray(tags)) {
            return tags;
        }

        if (typeof tags === "string") {
            return tags
                .split(",")
                .map((tag) => tag.trim())
                .filter(Boolean);
        }

        return [];
    }

    function productHasTag(productTags, tag) {
        return productTags.includes(tag);
    }

    function productIsType(product, type) {
        const productType = product.product_type || product.type;

        if (!productType) return false;

        return productType === type;
    }

    global.RENEWPurchaseRules = Object.freeze({
        rules,
        evaluate: evaluatePurchaseRules,
    });
})(typeof window !== "undefined" ? window : globalThis);